import { render, staticRenderFns } from "./assginCustomerModule.vue?vue&type=template&id=08249ef8&"
import script from "./assginCustomerModule.vue?vue&type=script&lang=js&"
export * from "./assginCustomerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports